module.exports = __webpack_public_path__ + "img/male_resultF.d3dc4e8a.png";